import { render } from "./PhoneCallForm.vue?vue&type=template&id=30c66e96"
import script from "./PhoneCallForm.vue?vue&type=script&lang=js"
export * from "./PhoneCallForm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1815703633/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__